import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { LoginService } from '../login.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent extends Busyable implements OnInit {

  public form: UntypedFormGroup;
  public ErrorMessage: string = "";
  public SuccessMessage: string = "";
  public code: string = '';

  constructor(
    private loginService: LoginService, 
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {
    super();
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
    });
  }

  ngOnInit(): void {
    // Check if we have a reset code in the URL
    this.route.queryParams.subscribe(params => {
      if (params['code']) {
        this.code = params['code'];
        // Pre-fill email if provided
        if (params['email']) {
          this.form.get('email')?.setValue(params['email']);
        }
      }
    });

    // Mark form as dirty so buttons work
    this.form.markAsDirty();
  }

  public async RequestPasswordReset() {
    if (this.form.get('email')?.invalid) {
      this.ErrorMessage = 'Please enter a valid email address';
      return;
    }

    this.Busy();
    this.ErrorMessage = '';
    this.SuccessMessage = '';

    try {
      const email = this.form.get('email')?.value;
      const result = await this.loginService.RequestPasswordReset(email);
      
      // Always respond generically to avoid user enumeration
      this.SuccessMessage = 'If an account exists for that email, password reset instructions have been sent.';
      this.toastr.success('If an account exists, a reset email has been sent.', 'Success');
      // Optionally keep telemetry:
      if (!result.Success) {
        const errMsg = (result.Error && (result.Error.Message || result.Error.message)) || result.Error || 'RequestPasswordReset failed';
        console.warn('[RequestPasswordReset] non-success:', errMsg);
      }
    } catch (error: any) {
      // Always respond with a generic success message to avoid account enumeration,
      // and log the real error internally for diagnostics.
      this.SuccessMessage = 'If an account exists for that email, password reset instructions have been sent.';
      console.warn('[RequestPasswordReset] exception:', error);
    } finally {
      this.StopBusy();
    }
  }


  public GoToLogin() {
    this.router.navigate(['/login']);
  }

  public KeyPress(evt: any) {
    if (evt.keyCode === 13) {
      this.RequestPasswordReset();
    }
  }
}
